"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptionsComponentElementDefinition = exports.ListComponentElementDefinition = exports.ComponentElementDefinition = void 0;

var _index = require("./index");

var _validation = require("./validation");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var ComponentRuleDefinition = _flowRuntime["default"].tdz(function () {
  return _validation.ComponentRuleDefinition;
});

var InheritedFieldValidation = _flowRuntime["default"].tdz(function () {
  return _validation.InheritedFieldValidation;
});

var InheritedComponentValidation = _flowRuntime["default"].tdz(function () {
  return _validation.InheritedComponentValidation;
});

var ElementDefinition = _flowRuntime["default"].tdz(function () {
  return _index.ElementDefinition;
});

var FieldInfoDefinition = _flowRuntime["default"].tdz(function () {
  return _index.FieldInfoDefinition;
});

var OptionDefinition = _flowRuntime["default"].tdz(function () {
  return _index.OptionDefinition;
});

var ComponentElementDefinition = _flowRuntime["default"].type("ComponentElementDefinition", _flowRuntime["default"].spread(_flowRuntime["default"].ref(ElementDefinition), _flowRuntime["default"].object(_flowRuntime["default"].property("info", _flowRuntime["default"].ref(FieldInfoDefinition), true), _flowRuntime["default"].property("inheritedComponentValidation", _flowRuntime["default"].array(_flowRuntime["default"].ref(InheritedComponentValidation)), true), _flowRuntime["default"].property("inheritedFieldValidation", _flowRuntime["default"].array(_flowRuntime["default"].ref(InheritedFieldValidation)), true), _flowRuntime["default"].property("isComponent", _flowRuntime["default"]["boolean"](true), true), _flowRuntime["default"].property("label", _flowRuntime["default"].string(), true), _flowRuntime["default"].property("title", _flowRuntime["default"].string(), true), _flowRuntime["default"].property("type", _flowRuntime["default"].any()), _flowRuntime["default"].property("validation", _flowRuntime["default"].array(_flowRuntime["default"].ref(ComponentRuleDefinition)), true))));

exports.ComponentElementDefinition = ComponentElementDefinition;

var ListComponentElementDefinition = _flowRuntime["default"].type("ListComponentElementDefinition", _flowRuntime["default"].spread(ComponentElementDefinition, _flowRuntime["default"].object(_flowRuntime["default"].property("defaultItems", _flowRuntime["default"].array(_flowRuntime["default"].ref(OptionDefinition)), true), _flowRuntime["default"].property("items", _flowRuntime["default"].array(_flowRuntime["default"].ref(OptionDefinition)), true))));

exports.ListComponentElementDefinition = ListComponentElementDefinition;

var OptionsComponentElementDefinition = _flowRuntime["default"].type("OptionsComponentElementDefinition", _flowRuntime["default"].spread(ComponentElementDefinition, _flowRuntime["default"].object(_flowRuntime["default"].property("options", _flowRuntime["default"].object(), true))));

exports.OptionsComponentElementDefinition = OptionsComponentElementDefinition;